import React from "react";
import { Spinner } from "react-bootstrap";
import "../../Styles/components/blur-loading.scss";

export default function BlurLoading({ show = false }) {
  if (!show) {
    return null;
  }

  return (
    <div
      className="blur-loading"
      aria-live="polite"
      aria-busy="true"
      role="presentation"
    >
      <div className="blur-loading__spinner" role="status" aria-label="Loading">
        <Spinner animation="border" />
      </div>
    </div>
  );
}
